var _SessionManager_privateKey;
import { __classPrivateFieldGet } from "tslib";
import { get, writable } from 'svelte/store';
import { SessionStorageModel } from './SessionStorageModel';
export class SessionManager {
    constructor() {
        _SessionManager_privateKey.set(this, writable(''));
        this.storage = new SessionStorageModel();
        this.subscribePrivateKey = __classPrivateFieldGet(this, _SessionManager_privateKey, "f").subscribe;
        __classPrivateFieldGet(this, _SessionManager_privateKey, "f").set(this.storage.privateKey);
    }
    setPrivateKey(privateKey) {
        __classPrivateFieldGet(this, _SessionManager_privateKey, "f").set(privateKey);
        this.storage.privateKey = privateKey;
    }
    getPrivateKey() {
        return get(__classPrivateFieldGet(this, _SessionManager_privateKey, "f"));
    }
}
_SessionManager_privateKey = new WeakMap();
